<template>
  <div class="c-survey-question">
    <div class="mask" v-if="isAdmin" />
    <h2>{{ currentSurvey.title }}</h2>
    <p>{{ currentSurvey.description }}</p>

    <hr />

    <div v-if="!isAnswered">
      <ol class="listless c-survey-question__list">
        <li
          v-for="question in currentSurvey.questions"
          :key="question.sortOrder"
        >
          <h3>{{ question.title }}</h3>
          <p>{{ question.description }}</p>

          <ol class="listless c-survey-question__list">
            <li v-for="choice in question.choices" :key="choice.sortOrder">
              <label :for="`choice_${question.sortOrder}_${choice.sortOrder}`">
                <input
                  type="radio"
                  :id="`choice_${question.sortOrder}_${choice.sortOrder}`"
                  :value="choice.sortOrder"
                  @input="updateAnswer(question.sortOrder, choice.sortOrder)"
                  :checked="answers[question.sortOrder - 1] == choice.sortOrder"
                />{{ choice.label }}
              </label>
            </li>
          </ol>
        </li>
      </ol>

      <p>
        <base-button
          type="button"
          :disabled="!isCompleted"
          primary="true"
          @click="confirmAnswer"
          >Submit</base-button
        >
      </p>
    </div>

    <div v-else>
      <p>Thank you for submitting your survey.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "form-poll",

  props: {
    poll: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      isAnswered: false,
      answers: [],
    };
  },

  computed: {
    ...mapState("Surveys", ["currentSurvey"]),
    isCompleted() {
      return this.answers.length >= this.currentSurvey.questions.length
    },
    isAdmin() {
      return this.$route.meta.isAdmin;
    },
  },
  methods: {
    updateAnswer(question, choice) {
      this.$set(this.answers, question-1, choice);
    },
    confirmAnswer() {
      this.$store.dispatch("createDialog", {
        confirm: this.setAnswered,
      });
    },
    setAnswered() {
      this.isAnswered = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-survey-question {
  position: relative;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__list {
    li {
      label {
        border: 2px solid $colour-nhs-med-grey;
        cursor: pointer;
        display: block;
        padding: 10px;

        input[type="radio"] {
          margin-right: 10px;
        }

        &:hover {
          background: $colour-nhs-pale-grey;
        }
      }

      & + li {
        margin-top: 10px;
      }
    }
  }
}
</style>
